import { render, staticRenderFns } from "./ServiceAreaToggle.vue?vue&type=template&id=46df2f4c&scoped=true&"
import script from "./ServiceAreaToggle.vue?vue&type=script&lang=js&"
export * from "./ServiceAreaToggle.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAreaToggle.vue?vue&type=style&index=0&id=46df2f4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46df2f4c",
  null
  
)

export default component.exports